import { Component } from '@angular/core';
import { Product, ProductScope, TranslatePipe } from '@spartacus/core';
import { CurrentProductService} from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'knbr-kn-br-product-literature',
    templateUrl: './kn-br-product-literature.component.html',
    styleUrls: ['./kn-br-product-literature.component.scss'],
    imports: [AsyncPipe, TranslatePipe]
})
export class KnBrProductLiteratureComponent   {

  product$: Observable<Product | null> = this.service
      .getProduct([ProductScope.DETAILS])
    constructor(
      protected service: CurrentProductService    
    ){}

}
